import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from "./components/Root/App";
const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App />);

window.addEventListener('error', e => {
	if (e && e.message && e.message.includes('ResizeObserver loop')) {
		e.stopImmediatePropagation();
	}
});

window.addEventListener('unhandledrejection', e => {
	if (e && e.reason && typeof e.reason === 'string' &&
			e.reason.includes('ResizeObserver loop')) {
		e.preventDefault();
	}
});
